import React, { useContext } from 'react'
import { ExternalLinkIcon, Text } from 'chemistry'
import { AttributeRow } from 'client/fragments/productDetailsFragmentInfo/components/Description/CollapsibleAttributes/AttributeRow'
import { TranslateContext } from 'client/common/translator'

const DocumentAttributeRow = ({ index, displayName, value, documentUrl }) => {
  return (
    <AttributeRow
      index={index}
      displayName={displayName}
      value={
        <>
          {value}
          <a href={documentUrl} target='_blank' rel='noreferrer' aria-label='PDF Doc'>
            <ExternalLinkIcon style={{ width: '16px', color: 'var(--chakra-colors-red-primary)' }} />
          </a>
        </>
      }
      flexBasis50={false}
    />
  )
}

const getLocalizedDocumentName = ({ baseTranslationCode, locale, t }) => {
  switch (locale) {
    case 'nl_BE':
      return `${t(baseTranslationCode)} - NL`
    case 'fr_BE':
      return `${t(baseTranslationCode)} - FR`
    case 'de_BE':
      return `${t(baseTranslationCode)} - DE`
    case 'en_US':
      return `${t(baseTranslationCode)} - EN`
    default:
      return t(baseTranslationCode)
  }
}

export const getDocumentName = ({ subType, id, locale } = {}, t) => {
  if (subType === 'ASSEMBLY_INSTRUCTIONS') return t('documents.assembly_instructions')
  if (subType === 'ENERGY_LABEL') return t('documents.energy_label')
  if (subType === 'TECHNICAL_DATA_SHEET') return t('documents.technical_data_sheet')
  if (subType === 'DECLARATION_OF_CONFORMITY') return t('documents.declaration_of_conformity')
  if (subType === 'HAZARDOUS_SUBSTANCES_DATA') return t('documents.hazardous_substances_data')
  if (subType === 'MONTAGE_IMAGE') return t('documents.montage_image')
  if (subType === 'OUT_OF_PACKAGE_IMAGE') return t('documents.out_of_package_image')
  if (subType === 'TECHNICAL_DRAWING') return t('documents.technical_drawing')
  if (subType === 'EPREL_PRODUCT_SHEET') {
    return getLocalizedDocumentName({ baseTranslationCode: 'documents.product_information_sheet', locale, t })
  }
  if (subType === 'REPAIRABILITY_INDEX') {
    return getLocalizedDocumentName({ baseTranslationCode: 'repairability_index.label', locale, t })
  }
  return id
}

export const getSafetyDocumentName = ({ subType } = {}, t) => {
  if (subType === 'DOP') return t('safety_documents.declaration_of_performance')
  if (subType === 'SDS') return t('safety_documents.safety_data_sheet')
  return ''
}

export const DocumentsList = ({ documents, safetyDocuments }) => {
  const t = useContext(TranslateContext)
  return (
    <div className='attr-section'>
      <Text as='b' my='4' display='block'>
        {t('cluster_documents')}
      </Text>
      <dl>
        {documents.map((doc, index) => (
          <DocumentAttributeRow
            key={doc.id}
            index={index}
            displayName='PDF'
            value={getDocumentName(doc, t)}
            documentUrl={doc.url}
          />
        ))}
        {safetyDocuments.map((doc, index) => (
          <DocumentAttributeRow
            key={doc.publicUrl}
            index={documents.length + index}
            displayName='PDF'
            value={getSafetyDocumentName(doc, t)}
            documentUrl={doc.publicUrl}
          />
        ))}
      </dl>
    </div>
  )
}
